(() => {
  const widgetSelector = '.collection-star-section.bk-reviews';

  const hideEmptyWidgets = (root) => {
    root.querySelectorAll(widgetSelector).forEach((widget) => {
      const count = widget.querySelector('.tw-text-custom');
      if (count && count.textContent.trim() === '(0)') {
        widget.hidden = true;
      }
    });
  };

  const start = () => {
    const root = document.querySelector('main') || document.body;
    hideEmptyWidgets(root);

    const observer = new MutationObserver(() => hideEmptyWidgets(root));
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
